// removed by extract-text-webpack-plugin
module.exports = {"table-field":"_3gT0rQhf-Atd_2UatZVyWV"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/containers/reportDetail/ReportDetailTableFieldTemplate.less
 ** module id = 254
 ** module chunks = 0
 **/